import { Component } from 'solid-js'
import PageHeader from '/web/shared/PageHeader'
import { markdown } from '/web/shared/markdown'
import { Page } from '/web/Layout'
import { i18nStore } from '/web/store'

const NovelGuide: Component = () => {
  const i18n = i18nStore((s) => ({ t: s.t }))

  return (
    <Page>
      <PageHeader title={i18n.t.guide_novel_title}></PageHeader>
      <div class="markdown" innerHTML={markdown.makeHtml(i18n.t.guide_novel_text)}></div>
    </Page>
  )
}

export default NovelGuide
